export const scrolledDownZeroVar = '--scrolled-down-zero';

export const scrolledDownVisibleVar = '--scrolled-down-visible';
